import { useState, useEffect, useMemo } from "react";

export function useEmergencyNotice(user, { setSelectedItem, setActiveTab }) {
  const [activeEmergencyNotice, setActiveEmergencyNotice] = useState(null);
  const [dismissedEmergencyNotices, setDismissedEmergencyNotices] = useState([]);

  useEffect(() => {
    try {
      const dismissed = localStorage.getItem("dismissedEmergencyNotices");
      if (dismissed) {
        setDismissedEmergencyNotices(JSON.parse(dismissed));
      }
    } catch (error) {
      console.error("Error loading dismissed emergency notices:", error);
    }
  }, []);

  // TODO: Replace with real emergency notices from eventsApi once wired.
  const checkForActiveEmergencyNotice = useMemo(() => {
    if (!user) return null;
    if (process.env.NODE_ENV !== "development") return null;

    // Keep this development reminder private to admins and Bernard's account.
    const canSeeSampleNotice =
      user.role === "admin" ||
      user.email?.trim().toLowerCase() === "williamssubscriptions@proton.me";
    if (!canSeeSampleNotice) return null;

    const mockNotice = {
      id: "emergency-1",
      title: "Severe Hail Storm Warning",
      description:
        "URGENT: Severe hail storm expected to hit Glenwood and surrounding areas within the next 2-3 hours. Bureau of Meteorology forecasts up to 100mm of hail with damaging winds. Please secure outdoor items, move vehicles under cover, and stay indoors.",
      eventType: "emergency-notice",
      location: "Glenwood, QLD",
      date: new Date().toISOString().split("T")[0],
      time: "14:30",
      startDate: new Date().toISOString().split("T")[0],
      startTime: "00:00",
      endDate: new Date().toISOString().split("T")[0],
      endTime: "23:59",
      organizer: "Sarah Mitchell",
      organizerName: "Sarah Mitchell",
      organizerId: "organizer-emergency",
      organizerRating: 5.0,
      organizerReviews: 0,
      eventRating: 5.0,
      eventReviews: 0,
      eventTestimonials: [],
      isRecurring: false,
    };

    if (dismissedEmergencyNotices.includes(mockNotice.id)) return null;
    return mockNotice;
  }, [user, dismissedEmergencyNotices]);

  useEffect(() => {
    setActiveEmergencyNotice(checkForActiveEmergencyNotice);
  }, [checkForActiveEmergencyNotice]);

  const handleDismissEmergencyNotice = () => {
    if (!activeEmergencyNotice) return;

    const newDismissed = [...dismissedEmergencyNotices, activeEmergencyNotice.id];
    setDismissedEmergencyNotices(newDismissed);
    setActiveEmergencyNotice(null);

    try {
      localStorage.setItem("dismissedEmergencyNotices", JSON.stringify(newDismissed));
    } catch (error) {
      console.error("Error saving dismissed emergency notices:", error);
    }
  };

  const handleViewEmergencyNoticeDetails = () => {
    if (!activeEmergencyNotice) return;

    const emergencyItem = {
      ...activeEmergencyNotice,
      exchangeType: "event",
    };

    setSelectedItem(emergencyItem);
    setActiveTab("item-details");
  };

  return {
    activeEmergencyNotice,
    handleDismissEmergencyNotice,
    handleViewEmergencyNoticeDetails,
  };
}
